module.exports = __webpack_public_path__ + "static/media/checkbox.e9c5c463.svg";